import { Reveal } from "./Reveal";
import { TRUST_ITEMS } from "@/lib/svenData";

// Factual credibility markers only — extend TRUST_ITEMS in svenData.js when
// the client provides real numbers (years in business, client count, Google rating).
export const TrustBar = () => (
  <section data-testid="trust-bar-section" className="bg-[#0b0b0c] border-b border-[#e7e2da]">
    <Reveal>
      <div className="max-w-10xl mx-auto px-5 sm:px-8 py-8 grid grid-cols-2 lg:grid-cols-6 gap-y-3">
        {TRUST_ITEMS.map((item, i) => (
          <div key={item} data-testid={`trust-item-${i}`} className={`flex items-center gap-3 px-2 sm:px-6 ${i > 0 ? "lg:border-l lg:border-[#e7e2da]" : ""}`}>
            <span className="h-1.5 w-1.5 rounded-full bg-[#c5a059] shrink-0" />
            <p className="font-mono-ov text-[9px] sm:text-[11px] tracking-[0.14em] uppercase text-[#f0f0f0]">{item}</p>
          </div>
        ))}
      </div>
    </Reveal>
  </section>
);
